<template>

  <ss-modal
    v-show="isModalVisible"
    title="Title"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      Podaj kwotę z tytułu wystawienia wezwania
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body">
      <d-form-row>
        <d-col
          v-if="isIncludeVat"
          md="6">
          <label>
            Koszt wezwania (netto)
          </label>
          <ss-price-input
            :class="{
              'disabled' : actionInProgress,
              'is-invalid' : lar_errors.has('penalty_amount__net')
            }"
            v-model="penaltyAmountNet"
            @input="setGrossForValue(penaltyAmountNet, 'penaltyAmount', 'penalty_amount')" />
          <div
            class="invalid-feedback"
            v-text="lar_errors.get('penalty_amount__net')">
          </div>
        </d-col>
        <d-col
          md="6">
          <label>
            Koszt wezwania <span v-if="isIncludeVat"> (brutto)</span>
          </label>
          <ss-price-input
            v-model="penaltyAmount"
            :disabled="isIncludeVat"
            :class="{'is-invalid' : lar_errors.has('penalty_amount')}" />
          <div
            class="invalid-feedback"
            v-text="lar_errors.get('penalty_amount')">
          </div>
        </d-col>
      </d-form-row>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Anuluj
      </d-button>
      <d-button
        @click.prevent="sendPaymentReminderSubmit"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">check</i> Potwierdź
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal'
import SsPriceInput from '@/components/common/SsPriceInput';
import LarErrors from '@/helpers/Errors';
import CommonUtils from '@/utils/CommonUtils';
import FormUtils from '@/utils/FormUtils';

export default {
  name: 'SendReminderModal',
  components: {
    SsModal,
    SsPriceInput,
    LarErrors
  },
  props: {
    defaultReminderPrice: {
      default: 0,
      type: [Number, String]
    },
    defaultReminderPriceNet: {
      default: 0,
      type: [Number, String]
    },
    isModalVisible: {
      default: false,
      type: Boolean
    },
    reminderDate: {
      default: null,
      type: String
    },
    scheduleId: {
      required: true,
      type: [String, Number]
    },
    isIncludeVat: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isModalVisible (newValue) {
      if (newValue) {
        this.penaltyAmount = this.defaultReminderPrice;
        this.penaltyAmountNet = this.defaultReminderPriceNet;
      }
    }
  },
  data () {
    return {
      actionInProgress: false,
      lar_errors: LarErrors,
      penaltyAmount: 0,
      penaltyAmountNet: null,
    }
  },
  methods: {
    sendPaymentReminderSubmit(){
      this.actionInProgress = true;

      axios.post('api/contract-reminders/add-reminder',
      {
        schedule_id: this.scheduleId,
        reminder_date: this.reminderDate,
        penalty_amount: this.penaltyAmount
      })
      .then(response => {
        this.actionInProgress= false;
        this.closeModal();

        if (response.data.status === 0) {
          Vue.swal({
            type: 'error',
            title: response.data.message,
            showConfirmButton: true,
          }).then(() => {
            this.closeModal(true);
          });
        } else {
          Vue.swal({
            type: 'success',
            title: 'Wezwanie zostało wysłane.',
            showConfirmButton: true,
          }).then(() => {
            this.closeModal(true);
          });
        }

        this.$bus.$emit('reload-contract');
        this.$bus.$emit('contract-reload-reminders');
      }).catch((error) =>{
        this.actionInProgress = false;
        this.closeModal();
        Vue.swal({
          type: 'warning',
          title: 'Wystąpił błąd',
          text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
          showConfirmButton: true,
        });
      })
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('send-reminder-modal-close', shouldReload);
    },
    async setGrossForValue (value, fieldPath, errorFieldName) {
      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        return;
      }

      let { value: grossValue, isError} = await FormUtils.getGrossValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
    }
  }
}
</script>
